import useQuery from 'shared/hooks/useQuery';
import { FireRating } from 'shared/types';

const useGetConcreteFireRatings = () => {
  const { data, error, isLoading, isError } = useQuery<FireRating[]>(
    'concrete-fire-ratings',
    'v1/concrete-elements/fire-ratings'
  );

  return {
    fireRatings: data,
    error,
    isLoading,
    isError,
  };
};

export default useGetConcreteFireRatings;
